/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { AnimalPawIcon16Light } from './AnimalPawIcon16Light';
import { AnimalPawIcon16Regular } from './AnimalPawIcon16Regular';
import { AnimalPawIcon16Solid } from './AnimalPawIcon16Solid';
import { AnimalPawIcon20Light } from './AnimalPawIcon20Light';
import { AnimalPawIcon20Regular } from './AnimalPawIcon20Regular';
import { AnimalPawIcon20Solid } from './AnimalPawIcon20Solid';
import { AnimalPawIcon24Regular } from './AnimalPawIcon24Regular';
import { AnimalPawIcon24Solid } from './AnimalPawIcon24Solid';
import { AnimalPawIcon32Regular } from './AnimalPawIcon32Regular';
import { AnimalPawIcon64Regular } from './AnimalPawIcon64Regular';
var sizes = {
    16: {
        light: AnimalPawIcon16Light,
        regular: AnimalPawIcon16Regular,
        solid: AnimalPawIcon16Solid,
    },
    20: {
        light: AnimalPawIcon20Light,
        regular: AnimalPawIcon20Regular,
        solid: AnimalPawIcon20Solid,
    },
    24: {
        regular: AnimalPawIcon24Regular,
        solid: AnimalPawIcon24Solid,
    },
    32: {
        regular: AnimalPawIcon32Regular,
    },
    64: {
        regular: AnimalPawIcon64Regular,
    },
};
export var AnimalPawIcon = forwardRef('AnimalPawIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
